<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 sm4>
        <heat></heat>
      </v-flex>
      <v-flex xs12 sm4>
        <timer></timer>
      </v-flex>
      <v-flex xs12 sm4>
        <ventil></ventil>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Heat from "./Heat.vue";
import Timer from "./Timer.vue";
import Ventil from "./Ventil.vue";

export default {
  components: {
    Heat,
    Timer,
    Ventil
  },
  data: () => ({}),
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name
    },
    isSmall() {
      if (this.breakpoint == "sm" || this.breakpoint == "xs") {
        return true;
      }
      return false;
    },
    isLarge() {
      if (
        this.$vuetify.breakpoint.name == "lg" &&
        this.$vuetify.breakpoint.name == "xl"
      ) {
        return true;
      }
      return false;
    },
    fontSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font_size_2"; // plus gros car en colonne
        case "sm":
          return "font_size_15"; // en ligne petit
        case "md":
          return "font_size_2";
        case "lg":
          return "font_size_3";
        case "xl":
          return "font_size_3";
        default:
          return ''
      }
    },
    blueBorder() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "blueBorderLarge"; // plus gros car en colonne
        case "sm":
          return "blueBorderSmall"; // en ligne petit
        case "md":
          return "blueBorderLarge";
        case "lg":
          return "blueBorderLarge";
        case "xl":
          return "blueBorderLarge";
        default:
          return ''
      }
    }
  },
  methods: {
    // retourne vrai si le beakpoint est celui en cours
    isBreakpoint(value) {
      return this.$vuetify.breakpoint.name == value;
    },

    isBreakpointMin(value) {
      var bpName = this.$vuetify.breakpoint.name;
      switch (value) {
        case "xs":
          return true;
        case "sm":
          if (
            bpName == "sm" ||
            bpName == "md" ||
            bpName == "lg" ||
            bpName == "xl"
          ) {
            return true;
          }
          break;
        case "md":
          if (bpName == "md" || bpName == "lg" || bpName == "xl") {
            return true;
          }
          break;
        case "lg":
          if (bpName == "lg" || bpName == "xl") {
            return true;
          }
          break;
        case "xl":
          if (bpName == "xl") {
            return true;
          }
          break;
      }
      return false;
    }
  }
};
</script>

<style>
.main_value_container {
  display: inline-block;
  background-color: #42c125;
  /* padding: 0 1.5rem 0.5rem 1.5rem; */
  padding: 0 1.5rem;
  border: 3px solid white;
  white-space: nowrap;
  border-radius: 20px;
}

.blueBorderLarge {
  border: 16px solid #667b8b !important;
}

.blueBorderSmall {
  border: 8px solid #667b8b !important;
}

.font_size_1 {
  font-size: 1em;
}

.font_size_15 {
  font-size: 1.5em;
}

.font_size_2 {
  font-size: 2em;
}

.font_size_3 {
  font-size: 3em;
}

.font_size_4 {
  font-size: 4em;
}

.font_size_5 {
  font-size: 5em;
}

.v-responsive__content {
  margin: auto;
}
</style>
